// The compare grid of the card kit (mockup round 084 card 17, the kit part;
// ui-map-interface.md §8 "The card family").
//
// Two or more columns of one catalogue: the same rows, a key at the left,
// and the better figure of each row marked with a filled triangle, a shape
// and not a colour. A row with no better (a role, a weight) marks none.
// The grid is the `body` of a card; the hull card of lane F calls it for
// COMPARE. It is for the catalogue only, never for two fleets on the map
// (R1307).

import { esc } from '../esc';

/** One row: the key, one value per column (trusted markup), and the column
 *  of the better value, or -1 when the row has no better. */
export interface CompareRow {
  key: string;
  vals: readonly string[];
  best: number;
}

/** The grid, one head cell per column. */
export function compareHtml(cols: readonly string[], rows: readonly CompareRow[]): string {
  const head = '<span class="ck-ch"></span>'
    + cols.map((c) => `<span class="ck-ch ck-cv">${esc(c)}</span>`).join('');
  const body = rows.map((r) => `<span class="ck-ck ck-cap">${esc(r.key)}</span>`
    + cols.map((_, i) => {
      const v = r.vals[i] ?? '';
      const mark = r.best < 0 ? '' : r.best === i ? ' w' : ' l';
      return `<span class="ck-cv${mark}">${v}</span>`;
    }).join('')).join('');
  return `<div class="ck-cmp" style="--cols:${cols.length}">${head}${body}</div>`;
}
